export default __webpack_public_path__ + "ad1cf3861496878b4e73f307eb6adc58.svg";